import PullTo from 'vue-pull-to'
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'

export default {
  components : {
    PullTo,
    PuffLoadingImage
  },

  data(){
    return {
      pullToTopConfig : {
        pullText          : 'ひっぱって前を読み込む',
        triggerText       : '離して更新',
        loadingText       : '更新中',
        doneText          : '',
        failText          : '更新失败',
        loadedStayTime    : 0,
        stayDistance      : 50,
        triggerDistance   : 70
      },

      isEnbleTopBounce  : false,

      isPullToRunning   : false,
    };
  },

  methods : {
    async handlePullToLoad(loaded){
      // console.log(this.lastPage);
      // console.log(this.page);
      // console.log(this.currentPage);
      this.isPullToRunning = true;
      if(!(this.currentPage >= this.lastPage)){
        const nextPage = (this.currentPage + 1);

        // console.log('[PULL TO: PodRoom => '+this.podRoomId+' PAGE: '+nextPage+']');

        this.$store.dispatch({
          type        : 'connection/updatePodRoomData',
          podRoomId   : this.podRoomId,
          page        : nextPage,
          currentPage : nextPage
        });

        await this.waitLoading(
          this.$apollo.queries.podMessages.loading, 1000, 5
        );
      }

      this.isPullToRunning = false;

      loaded('done');
    },

    initializeHandleScroll(){
      window.removeEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.handleScroll);

      // 最初のイベントを発行します。
      this.handleScroll();
    },

    handleScroll(){
      // もしも最新を取得するボタンが作動中の場合はpulltoできません。
      if(this.isLoadingFetchButton === true){
        this.isEnbleTopBounce = false;
        return;
      }

      // それ以外はOK
      if(window.scrollY <= 0){
        this.isEnbleTopBounce = true;
      }else{
        this.isEnbleTopBounce = false;
      }
    },
  },

  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted(){
    this.$on('handleAfterEnter', this.initializeHandleScroll);
  }
}